import { render } from "./CustomCountDisplay.vue?vue&type=template&id=083584e1&scoped=true"
import script from "./CustomCountDisplay.vue?vue&type=script&lang=js"
export * from "./CustomCountDisplay.vue?vue&type=script&lang=js"

import "./CustomCountDisplay.vue?vue&type=style&index=0&id=083584e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-083584e1"]])

export default __exports__